<svelte:options customElement="trebol-wizard" />

<script lang="ts">
	import "./icons/logo.svelte";
	import "./icons/building.svelte";
	import { widgetState } from "./widget-store";
	let isOpen: boolean = $state(false);
	let currentStep = $state(1);
	let lastStep = 2;

	widgetState.subscribe((value) => {
		isOpen = value.isWizardOpen;
	});
	const goToNextStep = () => {
		currentStep = currentStep + 1;
	};
	const goToPrevStep = () => {
		currentStep = currentStep - 1;
	};
</script>

{#if isOpen}
	<div class="overlay">
		<div class="layout">
			<div class="step-container">
				<img
					src="https://uploads-ssl.webflow.com/62f40a5a7ac1b421563e663d/63d729b3737d360d10a948dd_Logo%20-%20Principal.svg"
					alt="trebol logo"
					width="80"
				/>
				{#if currentStep === 1}
					<div style="font-weight: bold; font-size: 1.5rem;margin-top: 40px;">
						Datos de la empresa
					</div>
					<div style="margin-top: 20px;text-align: center;font-weight:lighter;">
						Por favor, ingresa el NIT de tu empresa. Es necesario para validar tu información y
						continuar el proceso de onboarding
					</div>
					<div class="input-container">
						<input type="text" />
					</div>
				{/if}
				{#if currentStep === 2}
					<div style="font-weight: bold; font-size: 1.5rem;margin-top: 40px;">
						Composición de Accionistas
					</div>
					<div style="margin-top: 20px;text-align: center;font-weight:lighter;">
						Bríndanos tu documento de composición de accionistas para poder extraer y validar a los
						beneficiarios finales
					</div>
					<div class="input-container">
						<input type="file" />
					</div>
				{/if}
				{#if currentStep === 3}
					<div style="font-weight: bold; font-size: 1.5rem;margin-top: 40px;">
						Estamos validando tu información
					</div>
					<div style="margin-top: 20px;text-align: center;font-weight:lighter;">
						Gracias 🙏 por brindarnos tu información. Estamos validando tus datos
					</div>
				{/if}
			</div>
			<div class="navigation">
				{#if currentStep > lastStep}
					<button class="navigation-button" style="grid-column: span 2;">Actualizar</button>
				{:else}
					<button class="navigation-button" onclick={goToPrevStep} disabled={currentStep === 1}
						>Atrás</button
					>
					<button class="navigation-button" onclick={goToNextStep}>
						{#if currentStep === lastStep}
							Finalizar
						{:else}
							Siguiente
						{/if}
					</button>
				{/if}
			</div>
		</div>
	</div>
{/if}

<style>
	.navigation-button:disabled {
		background-color: #26970d2b;
		cursor: default;
	}
	.navigation-button {
		color: #fff;
		border: none;
		border-radius: 0.5rem;
		background-color: #26970d;
		padding: 1rem 2.5rem;
		cursor: pointer;
	}
	div.step-container {
		margin-bottom: auto;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	div.navigation {
		margin-top: auto;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-auto-flow: row dense;
		grid-gap: 0.5rem;
		width: 100%;
		/* justify-content: space-between; */
		padding: 1rem;
		justify-self: flex-end;
	}
	div.overlay {
		background-color: #dddddd;
		display: flex;
		align-items: center;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		justify-content: center;
		/* font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
			"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
			"Segoe UI Symbol", "Noto Color Emoji"; */
	}

	div.layout {
		background-color: #fff;
		min-height: 650px;
		width: 400px;
		border-radius: 0.5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 2rem 1.5rem;
	}

	div.input-container {
		margin-top: 40px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	div.input-container input {
		border-radius: 0.5rem;
		border: 1px solid #dcdcdc;
		font-size: 1.2rem;
		padding: 1rem 1.5rem;
	}
</style>
